import React, { forwardRef } from 'react';

import { Switch, SwitchProps } from '@chakra-ui/react';

const Toggle = forwardRef(({
  name,
  isDisabled,
  children,
  ...props
}:SwitchProps, ref:any) => (
  <Switch
    name={name}
    isDisabled={isDisabled}
    ref={ref}
    colorScheme="secondary"
    {...props}>
    {children}
  </Switch>
));

export default Toggle;
